import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import { availableHotspots } from '../../../../utils/tshirtHotspots';
import Tabs from '../../../../components/common/Tabs';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';
import { IS_TAB } from '../../../../utils/common';
import Carousel from '../../../../components/common/Carousel';

const Badge = ({
  options,
  updatePartsConfig,
  partsConfig,
  allCategoryCustomizations,
  selectedCategory,
  setHotspot,
  setOpenActionPanel
}) => {
  // const [activePrint, setActivePrint] = useState(
  //   initialSelectedCustomizationIndex
  // );
  const [activeHotspotCode, setActiveHotspotCode] = useState(
    selectedCategory === 'sleeve' ? 'SL' : 'TL'
  );
  const [tabs, setTabs] = useState(
    selectedCategory === 'sleeve'
      ? ['left', 'right']
      : ['1', '2', '3', '4', '5']
  );
  const [activeTab, setActiveTab] = useState(
    selectedCategory === 'sleeve' ? 'left' : '1'
  );
  // useActiveStateSelector('frontBadge', options, partsConfig, setActivePrint);
  const tabHotspotMap = {
    left: 'SL',
    right: 'SR',
    '1': 'TL',
    '2': 'CT',
    '3': 'TR',
    '4': 'BL',
    '5': 'BR'
  };
  useEffect(() => {
    if (selectedCategory === 'sleeve') {
      setActiveHotspotCode('SL');
      setHotspot('SL');
      setTabs(['left', 'right']);
    } else {
      setActiveHotspotCode('TL');
      setHotspot('TL');
      setTabs(['1', '2', '3', '4', '5']);
    }
  }, [selectedCategory]);

  useEffect(() => {
    setActiveHotspotCode(tabHotspotMap[activeTab]);
    setHotspot(tabHotspotMap[activeTab]);
  }, [activeTab]);
  useEffect(() => {
    if (window.ScapicSDK) {
      window.addEventListener(
        window.ScapicSDKEvents.HotspotClickEvent.is,
        data => {
          const hotspot = data.detail.data.partId;
          const partId = hotspot.includes('H')
            ? hotspot.substring(1, 3)
            : hotspot.substring(0, 2);

          let tabToBeSelected = '';
          Object.keys(tabHotspotMap).forEach(x => {
            if (tabHotspotMap[x] === partId) {
              tabToBeSelected = x;
            }
          });
          // setActiveHotspotCode(partId);
          // setHotspot(partId);
          setActiveTab(tabToBeSelected);
          if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            )
          ) {
            setOpenActionPanel(true);
          }
        }
      );
    }
  }, [window.ScapicSDK]);

  // useEffect(() => {
  //   setActivePrint(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);
  const selectedBadge = Object.keys(partsConfig[selectedCategory]).find(
    key =>
      key.includes(activeHotspotCode) &&
      partsConfig[selectedCategory][key] === true
  );

  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();
  return (
    <div className="front-badge">
      <Tabs
        columns={tabs.length}
        selectedTab={activeTab}
        setSelectedTab={tab => {
          setActiveTab(tab);
          // setActiveHotspotCode('SR')
        }}
        className="front-badge-sticky"
        options={tabs}
      />
      {IS_TAB ? (
        <Carousel noOfItems={options && options.length} itemWidth={cardWidth}>
          {options.map(option => (
            <div
              ref={cardRef}
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`front-badge-image  ${selectedBadge ===
                (option.partId.length === 4
                  ? activeHotspotCode + option.partId
                  : option.partId.replace(
                      option.partId.substring(0, 2),
                      activeHotspotCode
                    )) && 'front-badge-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                // setActivePrint(i);
                const selected = option;
                const partId =
                  option.partId.length === 4
                    ? activeHotspotCode + option.partId
                    : option.partId.replace(
                        option.partId.substring(0, 2),
                        activeHotspotCode
                      );

                selected.partId = partId;

                const ignoredList = [];
                allCategoryCustomizations.forEach(cust => {
                  if (selectedCategory === 'frontBadge') {
                    availableHotspots
                      .filter(part => !part.includes('S'))
                      .forEach(hotspot => {
                        const hotspotCode = hotspot.substring(1, 3);
                        const part =
                          cust.partId.length === 4
                            ? hotspotCode + cust.partId
                            : cust.partId.replace(
                                cust.partId.substring(0, 2),
                                hotspotCode
                              );
                        if (hotspotCode !== activeHotspotCode) {
                          ignoredList.push(part);
                        }
                      });
                  } else {
                    availableHotspots
                      .filter(part => part.includes('S'))
                      .forEach(hotspot => {
                        const hotspotCode = hotspot.substring(1, 3);
                        const part =
                          cust.partId.length === 4
                            ? hotspotCode + cust.partId
                            : cust.partId.replace(
                                cust.partId.substring(0, 2),
                                hotspotCode
                              );
                        if (hotspotCode !== activeHotspotCode) {
                          ignoredList.push(part);
                        }
                      });
                  }
                });
                // currOption.partId = partId;
                if (
                  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                  )
                ) {
                  // setOpenActionPanel(false);
                }
                updatePartsConfig(selected, selectedCategory, ignoredList);
              }}
            />
          ))}
        </Carousel>
      ) : (
        <GridLayout isResponsive>
          {options.map(option => (
            <div
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`front-badge-image  ${selectedBadge ===
                (option.partId.length === 4
                  ? activeHotspotCode + option.partId
                  : option.partId.replace(
                      option.partId.substring(0, 2),
                      activeHotspotCode
                    )) && 'front-badge-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                // setActivePrint(i);
                const selected = option;
                const partId =
                  option.partId.length === 4
                    ? activeHotspotCode + option.partId
                    : option.partId.replace(
                        option.partId.substring(0, 2),
                        activeHotspotCode
                      );

                selected.partId = partId;

                const ignoredList = [];
                allCategoryCustomizations.forEach(cust => {
                  if (selectedCategory === 'frontBadge') {
                    availableHotspots
                      .filter(part => !part.includes('S'))
                      .forEach(hotspot => {
                        const hotspotCode = hotspot.substring(1, 3);
                        const part =
                          cust.partId.length === 4
                            ? hotspotCode + cust.partId
                            : cust.partId.replace(
                                cust.partId.substring(0, 2),
                                hotspotCode
                              );
                        if (hotspotCode !== activeHotspotCode) {
                          ignoredList.push(part);
                        }
                      });
                  } else {
                    availableHotspots
                      .filter(part => part.includes('S'))
                      .forEach(hotspot => {
                        const hotspotCode = hotspot.substring(1, 3);
                        const part =
                          cust.partId.length === 4
                            ? hotspotCode + cust.partId
                            : cust.partId.replace(
                                cust.partId.substring(0, 2),
                                hotspotCode
                              );
                        if (hotspotCode !== activeHotspotCode) {
                          ignoredList.push(part);
                        }
                      });
                  }
                });
                // currOption.partId = partId;
                if (
                  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                  )
                ) {
                  // setOpenActionPanel(false);
                }
                updatePartsConfig(selected, selectedCategory, ignoredList);
              }}
            />
          ))}
        </GridLayout>
      )}
    </div>
  );
};

Badge.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object,
  allCategoryCustomizations: PropTypes.array,
  selectedCategory: PropTypes.string,
  setHotspot: PropTypes.func,
  setOpenActionPanel: PropTypes.func
};

export default Badge;
